import { render, staticRenderFns } from "./turnTable.vue?vue&type=template&id=92f44df4&scoped=true&"
import script from "./turnTable.vue?vue&type=script&lang=js&"
export * from "./turnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f44df4",
  null
  
)

export default component.exports